class PlayerJs {
    init() {
        const cardVideoPlayers = document.getElementsByClassName("js-card-video-player");
        const that = this;

        if(cardVideoPlayers.length) {
            window['PlayerjsAsync'] = function(){
                for(let i = 0; i < cardVideoPlayers.length; i++){
                    const playerElm = cardVideoPlayers[i];
                    const playerId = playerElm.id;
                    // Player type is the index of the player defined in the playerjs editor. See: https://playerjs.com/docs/en=combine
                    // Player type 1 is the video row player; player type 2 is the video card player. Default = video row player (1)
                    const playerType = playerElm.dataset.playerType || 1;
                    const videourl = playerElm.dataset.videourl || null;
                    const attribution = playerElm.dataset.attribution || null;
                    const poster = playerElm.dataset.poster || null;
                    // console.log(playerId, videourl, attribution, poster)
                    if(playerId && videourl){
                        that.createPlayer(playerId, videourl, playerType, attribution, poster);
                    }
                }
            }
            const event = new Event('playerjsAsyncFunctionReady');
            document.dispatchEvent(event);

            window['PlayerjsEventsFeaturedCard'] = function(event, id, data) {
                // console.log(event, id, data);
                if(event === "play"){
                    document.getElementById(id).classList.add('no-vignette');
                }
                if(event === "userpause"){
                    document.getElementById(id).classList.remove('no-vignette');
                }
                if(event === "end"){
                    document.getElementById(id).classList.remove('no-vignette');
                }
            }

          window['PlayerjsEventsVideoRow'] = function(event, id, data) {
            // console.log(event, id, data);
            if(event === "userpause"){
              document.getElementById(id).classList.remove('no-vignette');
            }
            if(event === "end"){
              document.getElementById(id).classList.remove('no-vignette');
            }
            // ui is the control panel showing up when the user hovers the video while playing
            if(event === "ui"){
              if(data === "1"){
                document.getElementById(id).classList.remove('no-vignette');
              }
              else {
                document.getElementById(id).classList.add('no-vignette');
              }
            }
          }
        }


    }

    createPlayer(playerId, videourl, playerType = 1, attribution = null, posterUrl = null) {
        const options = {
            id: playerId,
            file: videourl,
            design: playerType
        }

        if(posterUrl) {
            options["poster"] = posterUrl;
        }

        const player = new Playerjs(options);

        if (attribution) {
            player.api('title', attribution);
        }

        return player;
    }
}

export { PlayerJs };